import { TitleSection } from '../../../title-section'
import React from 'react'
import { Tab, Row, Nav, Col } from 'react-bootstrap'
import { FeatureTabContent } from '../../../feature-tab-content'

export const FeatureSection = () => (
  <section id="features" className="features">
    <div className="container">
      <TitleSection title="Features" description="Our Principal Top Features" />

      <Tab.Container id="principal-features-tab" defaultActiveKey="payment-info">
        <Row>
          <Col lg={3}>
            <Nav variant="tabs" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="payment-info">On-time payment info</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="on-time-milk">On-time tests and milk pickup results</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="print-reports">Printable reports</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="multi-records">Multi-Principal records</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>

          <Col lg={9} className="mt-4 mt-lg-0">
            <Tab.Content>
              <Tab.Pane eventKey="payment-info">
                <FeatureTabContent
                  title="On-time payment info"
                  description="Access the full producer payment information anywhere + anytime."
                  featureImage="./assets/img/principal-app/dashboard-removebg-preview.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="on-time-milk">
                <FeatureTabContent
                  title="On-time tests and milk pickup results"
                  description="Review your milk pickups and tests anytime of the year, month or even days."
                  featureImage="./assets/img/principal-app/test-pdf-removebg-preview.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="print-reports">
                <FeatureTabContent
                  title="Printable reports"
                  description="Download or preview your checks, test reports and and payroll history."
                  featureImage="./assets/img/principal-app/check-removebg-preview.png"
                />
              </Tab.Pane>

              <Tab.Pane eventKey="multi-records">
                <FeatureTabContent
                  title="Multi-Principal records"
                  description="Access multiple principal records with just one account, useful when your nutritionist needs to review the the milk weights and test results."
                  featureImage="./assets/img/principal-app/principal-mobile.png"
                />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  </section>
)
